import { API_MAP, agent, functions } from 'helpers';
import moment from 'moment';

class QuestionsService {
  static listQuestions(pagination: any, filters?: any) {
    let dateStart = '';
    let dateEnd = '';
    let productId = '';
    let customer = '';

    if (filters) {
      if (filters.start) {
        dateStart = '&asked_at=' + moment(filters.start).format('DD/MM/YYYY');
      }

      if (filters.end) {
        dateEnd = '&asked_at_final=' + moment(filters.end).format('DD/MM/YYYY');
      }

      if (filters.content && filters.content !== 'not-selected') {
        productId = '&product_id=' + filters.content;
      }

      if (filters.client) {
        if (Number(filters.client)) {
          customer = '&asker_id=' + filters.client;
        } else if (functions.emailIsValid(filters.client)) {
          customer = '&asker_email=' + filters.client;
        } else {
          customer = '&asker_name=' + filters.client;
        }
      }
    }

    return agent.get(
      `${API_MAP.listQuestions}?per_page=${pagination.per_page}&page=${pagination.current_page}${dateStart}${dateEnd}${productId}${customer}`
    );
  }

  static listChatQuestions(chat_id: number) {
    return agent.get(`${API_MAP.listChatQuestions.replace('{chat_id}', chat_id.toString())}`);
  }

  static answerQuestion(chat_id: number, content: string) {
    return agent.post(`${API_MAP.answerQuestion.replace('{chat_id}', chat_id.toString())}`, { answer: content });
  }

  static updateQuestion(chat_id: number, id: number, questionUpdate: any) {
    return agent.put(`${API_MAP.updateQuestion.replace('{chat_id}', chat_id.toString()).replace('{id}', id.toString())}`, questionUpdate);
  }
}
export default QuestionsService;
